import { useAuth } from "context/useAuth";
import { ReactElement } from "react";
import NotAuthorized from "views/Error/NotAuthorized";

const PrivateRoute = ({ children }: { children: ReactElement }) => {
  const { user } = useAuth();
  console.log("the user", user);

  return user?.username ? children : <NotAuthorized />;
};

export default PrivateRoute;
